import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const CourseInstructorsView = ({ assignedInstructors, instructorsViewModalOpen, setInstructorsViewModalOpen }) => {
  // const [anchorEl, setAnchorEl] = useState(null);

  // const handleClick = (event) => {
  //   setAnchorEl(event.currentTarget);
  // };

  // const handleClose = () => {
  //   setAnchorEl(null);
  // };

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };

  return (
    <>
      {instructorsViewModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white w-[90%] max-w-2xl max-h-[80vh] overflow-y-auto rounded-lg shadow-lg p-6 relative">

            {/* Modal Header */}
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-semibold text-gray-800">
                Course Instructors
              </h2>
              <button
                className="text-gray-500 hover:text-gray-700 text-xl font-bold"
                onClick={() => setInstructorsViewModalOpen(false)}
              >
                &times;
              </button>
            </div>

            {/* Table */}
            <div className="overflow-x-auto">
              <table className="min-w-full border text-left text-sm">
                <thead className="bg-gray-800 text-white">
                  <tr>
                    <th className="py-2 px-4 border-b">Name</th>
                    <th className="py-2 px-4 border-b">Email</th>
                  </tr>
                </thead>
                <tbody>
                  {assignedInstructors?.map((instructor, index) => (
                    <tr key={index} className="hover:bg-gray-100">
                      <td className="py-2 px-4 border-b">{instructor.firstname}</td>
                      <td className="py-2 px-4 border-b">{instructor.email}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Footer */}
            <div className="flex justify-end mt-4">
              <button
                className="bg-blue-600 hover:bg-blue-500 text-white font-medium py-2 px-4 rounded transition"
                onClick={() => setInstructorsViewModalOpen(false)}
              >
                Close
              </button>
            </div>

          </div>
        </div>
      )}
    </>
  );
};

export default CourseInstructorsView;
